module.exports = __webpack_public_path__ + "img/0020.682d938b.jpg";